import React from "react";
import { TMSSearchTextTransport } from "./tms-filters-search-transport";

export const TMSFiltersTransport = () => {
    return (
        <TMSSearchTextTransport /> 
  );
};
